import { createContext, useContext, type ReactNode } from 'react'

const StaticNoAnimationContext = createContext(false)

export function StaticNoAnimationProvider({
  children,
}: {
  children: ReactNode
}) {
  return (
    <StaticNoAnimationContext.Provider value={true}>
      {children}
    </StaticNoAnimationContext.Provider>
  )
}

export function useStaticNoAnimation() {
  return useContext(StaticNoAnimationContext)
}
